import moment, {Moment} from "moment";
import {IFilterService} from "angular";

type PriceFilter = (num: number, points: boolean) => string;
type DaysFilter = (from: Moment, to: Moment) => string;
type CurrencyFilter = (num: number, precision: number) => string;

export function tooltipGenerator($filter: IFilterService, priceSteps: Array<any>, points: boolean) {

    const priceFilter = $filter<PriceFilter>("price");
    const numberFormat = $filter<CurrencyFilter>("tfcurrency");
    const daysFilter = $filter<DaysFilter>("daysFromNow");
    const steps = (priceSteps.length - 1) / 2;

    return function contentGenerator(event: any) {

        const expiry = event.series[event.series.length - 1].key;

        const priceIndex = event.value + steps;
        const price = priceSteps[priceIndex];
        const header = `Price ${priceFilter(price, points)}`;

        const content = event.series.map((row: any) => formatRow(row, expiry)).join("\n");
        return `<h3>${header}</h3><table><tbody>${content}</tbody></table>`;
    };

    function formatRow(row: any, expiry: number) {
        const rowClass = row.highlight ? "highlight" : "";
        const valueClass = row.value < 0 ? "sell" : "buy";
        const difference = daysFilter(moment(expiry, "MMM Do YYYY"), moment(row.key, "MMM Do YYYY"));

        return `<tr class="${rowClass}">
                    <td class="legend-color-guide" style="border-color: ${row.color}">
                        <div style="background-color:${row.color}""></div>
                    </td>
                    <td class="key" style="border-color: ${row.color}">
                        ${row.key}
                        <div style="font-size: 11px">${difference} days to expiry</div>
                    </td>
                    <td class="value" style="font-size: 1.1em; border-color: ${row.color};">
                    <span class="${valueClass}">${numberFormat(row.value, 2)}</span>
                    </td>
                </tr>`;
    }
}
